var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"color/all",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }